export default __webpack_public_path__ + "static/media/website_setup.f498253e.svg";